import React, { Component, PropTypes } from 'react';
import { Card, Modal, Row, Col, Spin, Input, Form, Icon, Button } from 'antd';
import Editor from 'components/Form/WYSIWYG';

import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { editTeacher, getTeacherById } from 'data/teacher';
import _ from 'lodash';

import classes from '../styles/teacher/TeacherInfo.module.scss';

const FormItem = Form.Item;
const { TextArea } = Input;

class TeacherInfoTab extends Component {
  constructor(props) {
    super(props);
    this.onToggleMode = this.onToggleMode.bind(this);
    this.handleCloseImage = this.handleCloseImage.bind(this);
    this.showImageModal = this.showImageModal.bind(this);

    let profileEditorState;

    this.state = {
      collapseMobile: [],
      isPreview: true,
      showModal: false,
    };
  }

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }

  showImageModal(url) {
    this.setState({
      showModal: true,
      imageUrl: url,
    });
  }

  handleCloseImage() {
    this.setState({
      showModal: false,
      imageUrl: '',
    });
  }

  handleUpdateProfile(id) {
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      console.log('Received values of form: ', values);
      if (!err) {
        const newTeacher = _.merge(values, {});
        await editTeacher(id, newTeacher);
        // browserHistory.push('/teacher
        await this.props.getTeacherById(id);
        this.setState({ isPreview: true });

        console.log('Received values of form: ', values);
      }
    });
  }

  renderModal() {
    const imageUrl = this.state.imageUrl;

    if (!this.state.showModal) {
      return <div />;
    }
    return (
      <Modal width="960px" className={classes.imageModal} title="" visible={this.state.showModal} onCancel={this.handleCloseImage} footer={null}>
        <img src={imageUrl} />
      </Modal>
    );
  }

  renderPreviewItem(title, value, isBlockContent) {
    let contentSize = 18;
    let titleSize = 6;
    if (isBlockContent) {
      contentSize = 24;
      titleSize = 24;
    }
    return (
      <Row className={'ant-form-item'}>
        <Col className={cn('form-preview-title bold', { 'text-left': isBlockContent })} sm={titleSize}>
          <label>{title}</label>
        </Col>
        <Col className={cn('form-preview-content')} sm={contentSize}>
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </Col>
      </Row>
    );
  }

  renderPreviewMode() {
    const { teacher } = this.props;

    return (
      <div>
        <div className={'text-right pointer'} onClick={() => this.setState({ isPreview: false })}>
          <Icon type="edit" /> Edit Profile
        </div>
        {this.renderPreviewItem('เบอร์ติดต่อ: ', teacher.tel)}
        {this.renderPreviewItem('อีเมล: ', teacher.user.email)}
        {this.renderPreviewItem('แนะนำตัวสั้นๆ: ', teacher.introduction)}
        {this.renderPreviewItem('ทักษะ: ', teacher.skill)}
        {this.renderPreviewItem('โปรไฟล์: ', teacher.profile, true)}
        {this.renderPreviewItem('ช่องทางติดต่อทางโทรศัพท์', teacher.contactTel)}
        {this.renderPreviewItem('ช่องทางติดต่อทาง FB Messenger', teacher.contactFb)}
        {this.renderPreviewItem('ช่องทางติดต่อทาง Line', teacher.contactLine)}
        {this.renderPreviewItem('Website', teacher.website)}
        {this.renderPreviewItem('Facebook', teacher.facebook)}
        {this.renderPreviewItem('Instragram', teacher.instagram)}
        {this.renderPreviewItem('Twitter', teacher.twitter)}
      </div>
    );
  }

  renderEditorMode() {
    const { getFieldDecorator } = this.props.form;
    const { teacher } = this.props;
    return (
      <div>
        <div className={'text-right pointer red'} onClick={() => this.setState({ isPreview: true })}>
          <Icon type="close" /> Cancel Edit
        </div>
        <Form>
          <FormItem {...formItemLayout} hasFeedback label="ชื่อ">
            {getFieldDecorator('firstName', {
              rules: [
                {
                  required: true,
                  message: 'Please input firstName',
                },
              ],
              initialValue: teacher.name.first,
            })(<Input placeholder="ชื่อ" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="นามสกุล">
            {getFieldDecorator('lastName', {
              rules: [
                {
                  required: true,
                  message: 'Please input lastName',
                },
              ],
              initialValue: teacher.name.last,
            })(<Input placeholder="นามสกุล" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="Display name">
            {getFieldDecorator('displayName', {
              rules: [
                {
                  required: true,
                  message: 'Please input displayName',
                },
              ],
              initialValue: teacher.displayName,
            })(<Input placeholder="Display name" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="เบอร์ติดต่อ">
            {getFieldDecorator('tel', {
              rules: [
                {
                  required: true,
                  message: 'Please input เบอร์ติดต่อ',
                },
              ],
              initialValue: teacher.tel,
            })(<Input placeholder="เบอร์ติดต่อ" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="แนะนำตัวสั้นๆ">
            {getFieldDecorator('introduction', {
              rules: [
                {
                  required: true,
                  message: 'Please input แนะนำตัวสั้นๆ',
                },
              ],
              initialValue: teacher.introduction,
            })(<Input placeholder="แนะนำตัวสั้นๆ" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="ทักษะ">
            {getFieldDecorator('skill', {
              rules: [
                {
                  required: true,
                  message: 'Please input ทักษะ',
                },
              ],
              initialValue: teacher.skill,
            })(<Input placeholder="ทักษะ" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="โปรไฟล์">
            {getFieldDecorator('profile', {
              initialValue: teacher.profile,
            })(<Editor data={teacher.profile} limit={3000} />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="ช่องทางติดต่อทางโทรศัพท์">
            {getFieldDecorator('contactTel', {
              initialValue: teacher.contactTel,
            })(<Input placeholder="" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="ช่องทางติดต่อทาง FB Messenger">
            {getFieldDecorator('contactFb', {
              initialValue: teacher.contactFb,
            })(<Input placeholder="" />)}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="ช่องทางติดต่อทาง Line">
            {getFieldDecorator('contactLine', {
              initialValue: teacher.contactLine,
            })(<Input placeholder="" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="facebook">
            {getFieldDecorator('facebook', {
              initialValue: teacher.facebook,
            })(<Input placeholder="facebook" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="instagram">
            {getFieldDecorator('instagram', {
              initialValue: teacher.instagram,
            })(<Input placeholder="instagram" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="twitter">
            {getFieldDecorator('twitter', {
              initialValue: teacher.twitter,
            })(<Input placeholder="twitter" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="website">
            {getFieldDecorator('website', {
              initialValue: teacher.website,
            })(<Input placeholder="website" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="Remark">
            {getFieldDecorator('remark', {
              initialValue: teacher.remark,
            })(<TextArea placeholder="Remark" />)}
          </FormItem>
          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="primary" size="large" onClick={() => this.handleUpdateProfile(teacher._id)} loading={this.props.loading}>
              Save
            </Button>
            <Button type="danger" size="large" onClick={() => this.setState({ isPreview: true })}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  render() {
    // console.log(this.state.files);
    const { loading } = this.props;

    return (
      <div>
        {
          // <div>
          //    <Button type="primary" onClick={this.onToggleMode}> {this.state.mode === 'editor' ? 'Editor' : 'Preview'}</Button>
          //  </div>
        }
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <Row className="with-margin-top">
            <Col xs={24} span={24} className="with-padding-right">
              <Card bordered={false} noHovering={true}>
                {this.state.isPreview ? this.renderPreviewMode() : this.renderEditorMode()}
              </Card>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}
export default connect((state) => ({}), {})(Form.create()(TeacherInfoTab));
